<template>
    <div class="main">
        <template v-if="!loading">
            <template v-if="mode === 'Mobile'">
                <AppBar />
                <ModuleSwipe />
            </template>
            <div class="pc-container" v-if="mode === 'Pc'">
                <div class="pc-content">
                    <ViewDetails />
                    <QuestionCard />
                </div>
            </div>

            <van-popup
                position="bottom"
                get-container="body"
                :safe-area-inset-bottom="true"
                :duration="0.18"
                :closeable="true"
                v-model="showQuestionCard"
                @closed="onCloseQuestionCard"
                class="popup-question-card"
            >
                <QuestionCard />
            </van-popup>
        </template>
    </div>
</template>
<script>
import QuestionCard from './components/details/QuestionCard.vue'
import AppBar from './components/details/AppBar.vue'
import ModuleSwipe from './components/details/ModuleSwipe.vue'
import ViewDetails from './components/details/ViewDetails.vue'
import { getPaperBlockQuestions, getPaperInfo, getCollectionList, getPaperStashState } from '@/api/paperApi.js'
import { mapGetters } from 'vuex'

export default {
    components: { QuestionCard, AppBar, ModuleSwipe, ViewDetails },
    computed: {
        ...mapGetters(['userInfo']),
        complexTypes() {
            return this.$store.state.paperDetails.complexTypes
        },
        questionCardState() {
            return this.$store.state.paperDetails.questionCardState
        },
    },
    watch: {
        questionCardState: function () {
            this.showQuestionCard = this.questionCardState
        },
    },
    data() {
        return {
            loading: true,
            // Pc / Mobile
            mode: 'Pc',

            showQuestionCard: false,
        }
    },
    created() {
        this.mode = window.innerWidth > 900 ? 'Pc' : 'Mobile'
        this.onResize()
        window.onresize = this.onResize
        if (this.userInfo) {
            this.initPaperData()
        }
    },
    methods: {
        onCloseQuestionCard() {
            this.$store.dispatch('paperDetails/setQuestionCardState', false)
        },
        onResize() {
            this.$store.dispatch('paperDetails/setConfig', {
                clientWidth: document.documentElement.clientWidth,
                clientHeight: document.documentElement.clientHeight,
            })
            this.$store.dispatch('paperDetails/setQuestionCardState', false)

            clearTimeout(this.resizeTimer)
            this.resizeTimer = setTimeout(() => {
                const newMode = window.innerWidth > 900 ? 'Pc' : 'Mobile'
                if (this.mode !== newMode) {
                    this.mode = newMode
                    window.location.reload()
                }
            }, 300)
        },
        initPaperData() {
            const _paperNo = this.$route.params.paperNo
            Promise.all([
                getPaperInfo({ paperNo: _paperNo }),
                getCollectionList({ type: 'COLLECT', paperNo: _paperNo }),
                getPaperBlockQuestions({ paperNo: _paperNo }),
                getPaperStashState({ paperNo: _paperNo }),
            ]).then((res) => {
                // 试卷信息
                this.$store.dispatch('paperDetails/setPaperInfo', res[0].data)
                // 初始化收藏数据
                const collectionMap = {}
                res[1].data.forEach((item) => {
                    collectionMap[`q-${item.questionId}`] = true
                })
                this.$store.dispatch('paperDetails/setCollectionMap', collectionMap)

                // 暂存数据处理
                const stashMap = {}
                if (res[3]['data']) {
                    res[3]['data']['answers'].forEach((item) => {
                        if (item.answer) {
                            stashMap[`q-${item.questionId}`] = item.answer.split('@@')
                        }
                    })
                }
                // 题型处理: 添加序号，设置暂存数据，计算跳转位置
                let index = 1
                let jumpData = null
                res[2].data.forEach((mItem) => {
                    mItem.questions.forEach((item) => {
                        if (this.complexTypes.includes(item.type)) {
                            item.complexQuestion = true
                        }
                        if (!item.complexQuestion) {
                            item.indexNo = index
                            index = index + 1
                            item.stashAnswer = stashMap[`q-${item.id}`]

                            // 计算跳转位置
                            if (!stashMap[`q-${item.id}`] && !jumpData) {
                                jumpData = { questionId: item.id, subQuestionId: null }
                            }
                        }

                        if (item.complexQuestion && item.childQuestions) {
                            item.childQuestions.forEach((child) => {
                                child.indexNo = index
                                index = index + 1
                                child.content = child.content || ''
                                child.stashAnswer = stashMap[`q-${child.id}`]

                                // 计算跳转位置
                                if (!stashMap[`q-${child.id}`] && !jumpData) {
                                    jumpData = { questionId: item.id, subQuestionId: child.id }
                                }
                            })

                            // 统一替换 item.content 中的序号
                            if (item.content) {
                                let matchIndex = 0
                                const regex = /[（(]\d+[）)]/g
                                item.content = item.content.replace(regex, (match) => {
                                    matchIndex++
                                    if (matchIndex <= item.childQuestions.length) {
                                        return `(${item.childQuestions[matchIndex - 1].indexNo})`
                                    }
                                    return match // 保持原样
                                })
                            }
                        }
                    })
                })

                this.$store.dispatch('paperDetails/setModuleList', res[2].data)
                this.$store.dispatch('paperDetails/setBatchNo', res[3].data ? res[3].data.batchNo : null)
                this.loading = false
                // 渲染完成后跳转到
                this.$nextTick(() => {
                    if (jumpData && res[3].data) {
                        this.$store.dispatch('paperDetails/setJumpQuestion', jumpData)
                    }
                })

                // 开始计时
                let startTime = Date.now()
                if (res[3]['data'] && res[3]['data']['duration']) {
                    startTime -= res[3]['data']['duration'] * 1000
                }
                this.$store.dispatch('paperDetails/setAnswerTime', { startTime, endTime: Date.now() })
                setInterval(() => {
                    this.$store.dispatch('paperDetails/setAnswerTime', { endTime: Date.now() })
                }, 400)
                document.title = res[0].data.title
            })
        },
    },
}
</script>
<style>
html,
body {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}
.main {
    width: 100%;
    height: 100%;
}
/* 试题默认样式 */
.question-item {
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
    overflow-y: auto;
}
.question-title {
    font-size: 15px;
    color: #444;
    line-height: 1.8em;
}
.popup-question-card .question-card {
    max-height: 400px;
    height: 80vh;
}

.pc-container {
    background: #f5f5f5;
    height: 100vh;
    overflow-y: scroll;
}
.pc-content {
    max-width: 900px;
    margin: 20px auto;
    position: relative;
    display: flex;
}
.pc-container .view-container {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin-right: 16px;
    flex-grow: 1;
}
.pc-container .question-card {
    position: sticky;
    top: 0;
    flex-shrink: 0;
    width: 240px;
    height: 90vh;
    max-height: 800px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.pc-container .question-card .question-status {
    margin-right: 0;
}

.pc-container .module-list {
    height: calc(100% - 110px);
}
.pc-container .module-list .module-container {
    gap: 16px;
}
</style>
